import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SharedViewLogoType} from "./types";
import {SettingsMenuTopCategory} from "../settings-module";


export class SharedViewsModule extends ModuleProto {

    public logo     : SharedViewLogoType

    constructor(moduleConfig:any) {
        super(ModuleType.REQUESTS, moduleConfig);

        this.name                    = "Shared Views"
        this.description             = "Allows public sharing of any view in GoodDay"
        this.logo                    = _.get(moduleConfig,'logo', SharedViewLogoType.GOODDAY)
        this.settingsMenuTopCategory = SettingsMenuTopCategory.ORGANIZATION
    }


    toJson() {
        const result = super.toJson();

        if (this.logo !== SharedViewLogoType.GOODDAY) {
            result.logo = this.logo
        }

        return result
    }

}